export * from "ce/api/UserApi";
import { UserApi as CE_UserApi } from "ce/api/UserApi";

class UserApi extends CE_UserApi {}

export default UserApi;
